import { HttpClient, provideHttpClient } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { routes } from './app.routes';
import { provideRouter } from '@angular/router';
import { provideTranslateService } from "@ngx-translate/core";
import { DEFAULT_LANGUAGE } from 'src/app/app.constants';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CldrIntlService, IntlService } from '@progress/kendo-angular-intl';
import { RECAPTCHA_LOADER_OPTIONS, RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha-2';

import '@progress/kendo-angular-intl/locales/en/all';
import '@progress/kendo-angular-intl/locales/de/all';
import '@progress/kendo-angular-intl/locales/it/all';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: IntlService,
      useClass: CldrIntlService,
    },
    {
      provide: LOCALE_ID,
      useValue: DEFAULT_LANGUAGE
    },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: "RECAPTCHA_V3_SITE_KEY"
    },
    {
      provide: RECAPTCHA_LOADER_OPTIONS,
      useFactory: (locale: string) => ({
        onBeforeLoad(url: any) {
          url.searchParams.set("hl", locale);
          return { url };
        },
      }),
      deps: [LOCALE_ID],
    },
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes),
    provideHttpClient(),
    provideTranslateService({defaultLanguage: DEFAULT_LANGUAGE}),
    importProvidersFrom(
      BrowserAnimationsModule,
      RecaptchaV3Module,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      }),
    )
  ],
};
